export enum ACCESS_READY_FLOW {
  FIRST_LOGIN = 'firstlogin',
  NORMAL_LOGIN = 'normalLogin',
  TEMPORARY_PASSWORD_RECOVERY = 'temporaryPasswordRecovery',
}

export interface AccessReadyProps {
  onAccessReady: () => void;
  accessReadyFlow: ACCESS_READY_FLOW;
}
